module.exports = __webpack_public_path__ + "img/loading.7a48b19e.gif";